import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=53fe6855&"
import script from "./Navigation.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Navigation.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Navigation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports